<template>
  <gj-tool-group
      help
      download
      :download-url="downloadUrl"
      :download-params="downloadParams"
      :setting="tableName !== ''"
      :table-columns="tableColumns"
      task @clickTask="reloadTaskNumber"
      :task-tip="taskProgressNumber"
      :table-name="tableName">
    <template #task-content>
      <finance-profit-report-task ref="task"></finance-profit-report-task>
    </template>
  </gj-tool-group>
</template>

<script>
  import FinanceProfitReportTask from "../task/finance-profit-report-task";
  import {getAllProgressCount} from "../../../../../api/finance";
  import {isMeaningful} from "../../../../../utils/common";

  export default {
    name: "profit-report-tool",
    components: {FinanceProfitReportTask},
    props: {
      tableColumns: {
        type: Array,
        default() {
          return [];
        },
      },
      tableName: {
        type: String,
        default: '',
      },
      downloadUrl: {
        type: String,
      },
      downloadParams: {
        type: Object,
        default: () => {}
      },
      taskTip:null
    },
    data() {
      return {
        taskProgressNumber: null,
      }
    },
    created() {
      this.taskProgressNumber = this.taskTip;
      this.reloadTaskNumber();
    },
    watch:{
      taskTip:{
        handler(newCount,oldCount){
          this.taskProgressNumber = newCount
        }
      }
    },
    methods: {
      reloadTaskNumber() {
        getAllProgressCount()
          .then((data) => {
            if (isMeaningful(data) && !isNaN(data) && Number(data) !== 0) {
              this.taskProgressNumber = data;
            } else {
              this.taskProgressNumber = '';
            }
          });
        if (this.$refs && this.$refs.task) {
          this.$refs.task.$gjReset();
        }
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
